import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.CEC001.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the Contraction/Expansion coefficients between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plan at the following {row.data.length} cross-sections:
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell rowSpan={3}  style={{textAlign: 'left', verticalAlign: 'bottom'}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell colSpan={4}>Contraction/Expansion</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell colSpan={2}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                            <ResultHeaderCell colSpan={2}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell style={{width: 80, textAlign: 'right'}}>Cont</ResultHeaderCell>
                            <ResultHeaderCell style={{width: 80, textAlign: 'right'}}>Exp</ResultHeaderCell>
                            <ResultHeaderCell style={{width: 80, textAlign: 'right'}}>Cont</ResultHeaderCell>
                            <ResultHeaderCell style={{width: 80, textAlign: 'right'}}>Exp</ResultHeaderCell>
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            row.data.map(r => (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'left', width: 125}}><ComparisonCSName csName={r.cross_section} /></ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{r.base_exp}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{r.base_cntr}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r.base_exp, r.cmp_exp)}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r.base_cntr, r.cmp_cntr)}</ResultBodyCell>
                                </ResultRow>
                            ))
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const C12 = {
    RenderDescription,
}